import { motion } from "framer-motion";
import androidLogo from "@assets/images/android-logo.avif";
import iosLogo from "@assets/images/ios-logo.avif";
import CardComponent from "./CardComponent";

export const IoTDevelopmentServices = () => {
  return (
    <section className=" space-y-20 md:space-y-32 ">
      <section className="   space-y-14 ">
        {/* <div className=" mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12   "> */}
        <div className=" mx-auto md:w-11/12 lg:w-10/12 xl:w-8/12 px-5">
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[35px] lg:text-[40px] xl:text-[45px] text-center   font-bold text-dark font-butler"
          >
            Our IoT Development Services{" "}
          </motion.h2>
        </div>

        <div className="space-y-20 bg-gray-50 py-14 ">
          <div className="space-y-10  ">
            <motion.h3
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-[28px] lg:text-[35px] xl:text-[40px]  leading-[1.2]  text-center  font-bold text-dark font-butler"
            >
              IoT Product Development{" "}
            </motion.h3>
            <CardComponent range={[0, 3]} gridValue={3} />
          </div>
          <div className="space-y-10 ">
            <motion.h3
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true, amount: 0.3 }}
              className="text-[28px] lg:text-[35px] xl:text-[40px] 2xl:text-[40px] leading-[1.2]  text-center  font-bold text-dark font-butler"
            >
              IoT Software Development{" "}
            </motion.h3>

            <CardComponent range={[-4]} gridValue={2} />
          </div>
        </div>
      </section>
    </section>
  );
};
